// выставляем всем константу скрипта капчи,
// чтобы приложения могли при желании делать preload через link в head
export const CAPTCHA_SCRIPT_URL = "https://captcha-api.yandex.ru/captcha.js";
